export default ['/introduction.jsp', '/intro-build.jsp', '/intro-collect.jsp', '/intro-analyze.jsp'];
